// Task / event reminder on/off from the detail panels (Jade, 2026-10-05).
//
// Off does exactly what the edit panel's "Remove" button does: empties
// `reminders`. Three things already agree an empty array means "no reminder"
// (client collectors in taskLogic.js, the server scan in lib/reminder-logic.js,
// and AlarmSchedulerPlugin.reconcile() cancelling bookings no longer listed),
// so future alarms/notifications stop. The offsets are parked in
// `remindersOff` so turning it back on restores the same reminders.
export function hasReminderSetting(item) {
  return !!(item && ((item.reminders && item.reminders.length) || (item.remindersOff && item.remindersOff.length)));
}

export function remindersAreOn(item) {
  return !!(item && item.reminders && item.reminders.length);
}

export function setItemRemindersOn(item, on) {
  if (on) {
    if (remindersAreOn(item) || !(item.remindersOff && item.remindersOff.length)) return item;
    return { ...item, reminders: item.remindersOff, remindersOff: undefined };
  }
  if (!remindersAreOn(item)) return item;
  return { ...item, remindersOff: item.reminders, reminders: [] };
}
